'use strict';

export class WorklistHelper {
  public static PATIENT_DASHBOARD_TEST: string = 'patient_dashboard_tests';
  public static TEST_WORKLIST_TYPE: string = 'test';
  public static ONCOSIGNAL_WORKLIST_TYPE = 'oncosignal';
  public static REVISE_ACTION_KEY: string = 'revise';
  public static VALUESET_EDITOR_TYPE: string = 'valueset';
  public static PATHOLOGIST_ROUTE: string = 'Pathologist';
  public static ADMIN_VALUESET_EDITOR_TYPE: string = 'admin/settings/valueset';
}
